import React, { useState, useCallback, useRef } from 'react';
import HeadSub from '../../../../components/comm/HeadSub';
import { useLocation } from "react-router-dom";
import style from './Identity.module.css';

import axiosApi from '../../../../api/daonAxios';
import CODE from '../../../../constants/code';
import ToastPopup from '../../../../components/comm/ToastPopup';

const Identity = () => {
    const [toast, setToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');

    const location = useLocation();
    const { sns, accessToken, email, moveToMenu } = location.state || {};

    const stateIdRef = useRef(null);

    const saveStateOnServer = useCallback(async () => {
        if (sns && sns !== 'idpw' && sns !== 'phone') {
            try {
                const res = await axiosApi.post('/nice/auth/sns/token/save', { accessToken, sns });
                if (res.data?.resultCode === CODE.RCV_SUCCESS) {
                    const stateId = res.data?.result?.stateId;
                    stateIdRef.current = stateId;
                    return stateId;
                }
                throw new Error(res.data?.resultMessage || 'STATE_SAVE_FAILED');
            } catch (e) {
                console.error('state 저장 실패:', e);
                setToastMessage('본인확인 준비 중 오류가 발생했습니다. 잠시 후 다시 시도해 주세요.');
                setToast(true);
                throw e;
            }
        }
        return '';
    }, [accessToken, sns]);

    /**
     * 오리지날 나이스 리퀘스트
     * @type {(function(*): Promise<void>)|*}
     */
    const requestNiceAuth = useCallback(async (type, svc) => {
        try {
            const stateId = await saveStateOnServer();

            const providerType = type ? type : "idpw";

            const query = new URLSearchParams({
                svcType: svc || 'M',
                r1: stateId || '',
                emailAdres: email || '',
                moveToMenu: moveToMenu || ''
            }).toString();

            const url = `/nice/auth/request/${providerType}?${query}`;
            const res = await axiosApi.post(url, {});

            //console.log( " ==================> res : ", res );

            if (res.data?.resultCode !== CODE.RCV_SUCCESS) {
                setToastMessage(res.data?.resultMessage || '본인인증 요청에 실패했습니다.');
                setToast(true);
                return;
            }

            const authUrl = res.data?.result?.result?.authUrl;
            if (!authUrl) {
                setToastMessage('인증 URL이 없습니다.');
                setToast(true);
                return;
            }

            window.location.assign(authUrl);
        } catch (e) {
            console.error('NICE 인증 요청 실패:', e);
            setToastMessage('본인인증 요청 중 오류가 발생했습니다.');
            setToast(true);
        }
    }, [saveStateOnServer, sns, email, moveToMenu]);


    return (
        <>
            <HeadSub title="본인 확인" />

            <div id="sub-content" data-layout="white">
                <div className='inner-wrap' data-padding="30">
                    <strong className={style['title']}>본인확인 방법을 선택해 주세요</strong>

                    <div className={style['mid-box']}>
                        <button className={style['mobile']} onClick={() => requestNiceAuth(sns, "M")}>
                            <p>
                                <span>휴대폰</span>
                                <span>본인인증</span>
                            </p>
                        </button>

                        <button className={style['i-pin']} onClick={() => requestNiceAuth(sns, "I")}>
                            <p>
                                <span>아이핀</span>
                                <span>본인인증</span>
                            </p>
                        </button>
                    </div>
                </div>
            </div>

            {toast && (
                <ToastPopup
                    setToast={setToast}
                    message={toastMessage}
                    position="center"
                    opacity="90"
                />
            )}
        </>
    );
};

export default Identity;
